import { Col, Row } from "antd";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchAffiliateById } from "@/lib/api/resources/affiliates";
import { AffiliateDetailCard } from "./components/AffiliateDetailCard";
import { AffiliateDataImportCard } from "./components/AffiliateDataImportCard";

export const AffiliateDetail = () => {
  const { id } = useParams();
  const affiliateQuery = useQuery({
    queryKey: ["affiliate", id],
    queryFn: () => {
      if (!id) {
        throw new Error("No affiliate ID provided");
      }
      return fetchAffiliateById(id);
    },
  });

  if (!id) return null;

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <AffiliateDetailCard
          loading={affiliateQuery.isFetching}
          affiliate={affiliateQuery.data}
        />
      </Col>

      <Col span={12}>
        <AffiliateDataImportCard loading={affiliateQuery.isFetching} />
      </Col>
    </Row>
  );
};
